import _Button from "@material-ui/core/esm/Button";
import _FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import _Checkbox from "@material-ui/core/esm/Checkbox";
import _ExpandMore from "@material-ui/icons/esm/ExpandMore";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { makeStyles } from '@material-ui/core/styles';
import Loading from 'swag-client-common/components/info/loading/loading';
import Image from 'swag-client-common/components/ui/image';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import ColorsList from '../colors-list';
import { InputPantone } from '../input-pantone';
import { PRIMARY_BUTTON, DEFAULT_BUTTON } from '../../../../../../../../constants/styles';
import classes from '../../tools-panel.scss';
import toolbarItemAnimationClasses from './toolbar-item.anim.scss';
import revertButtonAnimationClasses from './revert-button.anim.scss';
import appearAnimationClasses from './appear.anim.scss';
import appearInputAnimationClasses from './appear-input.anim.scss';
import STYLES from './edit-colors-styles';
const useStyles = makeStyles(() => ({
  saveButton: _objectSpread({}, PRIMARY_BUTTON, STYLES.saveButton),
  revertButton: _objectSpread({}, DEFAULT_BUTTON, STYLES.revertButton),
  marginTop150: {
    marginTop: '150px'
  }
}));
export function EditColorsComponent({
  isOpened,
  onChangeOpenedState,
  loading,
  colors,
  isConverted,
  isLimitedEdition,
  onColorConvert,
  isRevertButtonShown,
  onRevertOriginalPreviewClick,
  onContinueClick,
  variantColor,
  preview,
  addColorEnabled,
  isBackgroundRemoved,
  isRemoveBGCheckboxShown,
  onRemoveBackgroundClick,
  onColorRemove,
  onColorAdd,
  isDisabled
}) {
  const myStyles = useStyles();
  const onToolbarClick = () => {
    if (loading || isDisabled) {
      return null;
    }
    onChangeOpenedState();
  };
  const onButtonConfirm = () => {
    onContinueClick();
    onChangeOpenedState();
  };
  return /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: toolbarItemAnimationClasses,
    in: isOpened,
    timeout: 500
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.toolbarItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toolbarItemMainColumn, {
      [classes.toolbarItemDisabled]: isDisabled
    })
  }, /*#__PURE__*/React.createElement("div", {
    onClick: onToolbarClick,
    className: classes.toolbarItemHead,
    tabIndex: isDisabled ? -1 : 0,
    "aria-label": "Edit Colors",
    onKeyDown: e => handleOnEnterPressed(e, onToolbarClick)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.toolbarItemIcon
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.coloredCircle,
    style: {
      backgroundColor: variantColor
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.toolbarItemHeadText,
    "data-button": "EditColors"
  }, "Edit Colors"), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toolbarItemExpand, {
      [classes.toolbarItemExpandReverse]: isOpened
    })
  }, /*#__PURE__*/React.createElement(_ExpandMore, null))), /*#__PURE__*/React.createElement("div", {
    className: classes.toolbarItemBody,
    "data-block": "EditColors"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toolbarItemBodyContent, {
      [classes.toolbarItemBodyContentHeightAdjusted]: isRemoveBGCheckboxShown
    })
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: appearAnimationClasses,
    key: colors.length,
    timeout: 300
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "We have detected", ' ', /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.titleHighlight, {
      [classes.orangeTitle]: isLimitedEdition
    })
  }, colors.length), ' ', "pantone color", colors.length > 1 ? 's' : '', ":", ' '))), isOpened && /*#__PURE__*/React.createElement(ColorsList, {
    isLoading: loading,
    isRemoveEnabled: isOpened,
    isConvertEnabled: true,
    hasColors: !!colors.length,
    colors: colors,
    isConverted: isConverted,
    onColorConvert: onColorConvert,
    onColorRemove: onColorRemove
  }), /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: appearInputAnimationClasses,
    in: addColorEnabled,
    timeout: 300,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.bodyText, classes.boldText)
  }, "Add color:"), isOpened && /*#__PURE__*/React.createElement(InputPantone, {
    shouldValidatePantone: false,
    isButtonDisabled: loading || isDisabled,
    isLimitedEdition: isLimitedEdition,
    onSubmit: onColorAdd
  }))), isRemoveBGCheckboxShown && /*#__PURE__*/React.createElement("div", {
    className: classes.checkboxWrapper
  }, /*#__PURE__*/React.createElement(_FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_Checkbox, {
      // disable when it's closed for tab navigation
      disabled: isDisabled || loading || !isOpened,
      id: "removeBackgroundCheckbox",
      name: "Remove background",
      checked: isBackgroundRemoved,
      onChange: onRemoveBackgroundClick
    }),
    label: "Remove background"
  }))), /*#__PURE__*/React.createElement(_Button, {
    onClick: onButtonConfirm
    // disable when it's closed for tab navigation
    ,
    disabled: loading || isDisabled || !isOpened,
    color: "primary",
    variant: "contained",
    className: classnames(myStyles.saveButton, {
      [myStyles.marginTop150]: isRevertButtonShown,
      [classes.orangeButton]: isLimitedEdition
    }),
    "data-button": "Confirm"
  }, "Confirm"))), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toolbarItemSideImage, {
      [classes.toolbarItemSideImageHidden]: !isOpened
    }),
    "data-block": "EditColorsSide"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.toolbarSideImageWrapper,
    style: {
      background: variantColor
    }
  }, loading ? /*#__PURE__*/React.createElement(Loading, null) : /*#__PURE__*/React.createElement(Image, {
    src: preview,
    style: {
      background: variantColor
    },
    alt: "preview"
  }), /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: revertButtonAnimationClasses,
    in: isRevertButtonShown,
    timeout: 500,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.revertButtonWrapper
  }, /*#__PURE__*/React.createElement(_Button, {
    onClick: onRevertOriginalPreviewClick,
    color: "default",
    variant: "contained",
    className: myStyles.revertButton,
    "data-button": "RevertToOriginal"
  }, "Revert to original")))))));
}